import RoundedButton, { ColorStyle } from 'components/RoundedButton';
import { useEnterStore } from 'hooks/stores/useEnterStore';
import { observer } from 'mobx-react-lite';
import { useState } from 'react';
import { Input, Message } from 'semantic-ui-react';
import { trackEvent } from 'utils/analytics/analytics';
import { renderReward } from '../payment-section/renderReward';

export const PromoCodeEntry = observer(() => {
  const {
    currentPromo,
    promoErrorMessage,
    applyPromo: applyPromoCode,
    isPaidSubscription,
    isCurrentPromoIntroOffer,
    initialised,
  } = useEnterStore();
  const [promoCodeStr, setPromoCodeStr] = useState(
    initialised && !isCurrentPromoIntroOffer && currentPromo
      ? currentPromo.code
      : '',
  );

  const [applyPromoCodeLoading, setApplyPromoCodeLoading] = useState(false);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        gap: 16,
      }}
    >
      {currentPromo &&
      !isCurrentPromoIntroOffer &&
      !promoErrorMessage ? (
        renderReward(currentPromo)
      ) : (
        <>
          <div
            style={{
              display: 'flex',
              width: '100%',
              justifyContent: 'center',
            }}
          >
            <Input
              placeholder="Enter promo code"
              type="text"
              autoComplete="off"
              autoCorrect="off"
              onChange={(e) => {
                setPromoCodeStr(e.target.value);
              }}
              className="neonInput"
              style={{
                borderRadius: '3px',
                fontSize: '15px', // Don't zoom in on iOS
                flex: 1,
                width: '100%',
              }}
              value={promoCodeStr}
              input={{ style: { width: '100%' } }}
            />

            <RoundedButton
              rebrandDm2025
              onClick={async () => {
                setApplyPromoCodeLoading(true);
                await applyPromoCode(promoCodeStr);
                setApplyPromoCodeLoading(false);
                trackEvent('Set Promo Code', { promoCodeStr });
              }}
              style={{
                marginLeft: '10px',
                minWidth: '120px',
                width: 'auto',
              }}
              loading={applyPromoCodeLoading}
              colorStyle={ColorStyle.Primary}
              href={undefined}
              className={undefined}
              id={undefined}
              disabled={
                promoCodeStr.trim().length === 0 || applyPromoCodeLoading
              }
              hoverColor={undefined}
              hoverTextColor={undefined}
              fullWidth
            >
              Use Code
            </RoundedButton>
          </div>
          {promoErrorMessage && (
            <Message negative style={{ margin: 0 }}>
              {promoErrorMessage}
            </Message>
          )}
        </>
      )}
    </div>
  );
});
